import { Controller } from '@hotwired/stimulus';
import { PaymentAccountsSearchMixin } from '../../../mixins/payment_accounts_search_mixin';
import { ClearPaymentAccountsMixin } from "../../../mixins/clear_payment_accounts_mixin";

export default class extends Controller {
  static targets = ['iban'];
  static values = {
    turboFrameTagName: String,
    selectSelector: String,
  };

  initialize() {
    PaymentAccountsSearchMixin(this);
    ClearPaymentAccountsMixin(this);
    this.initialize_payment_accounts_search();
  }

  clear_results() {
    this.clear_payment_accounts(
      this.selectSelectorValue,
      this.turboFrameTagNameValue,
    );
  }

  additional_turbo_params() {
    return { additional_render: 'panel/needies/aids/iban' };
  }

  clear_payment_accounts_callback() {
    this.ibanTarget.value = '';
  }
}
